export enum TaskDetailsTab {
  Discussion = 'discussion',
  History = 'history',
  Subtasks = 'subtasks',
}
